import Link from "next/link";
import './styles/_support-k8s-platform.module.scss';

const SupportK8sPlatforms = () => {
    return <>
        <section className={`support-k8s-platforms`}>
            <div className={'container'}>
                <div className="d-flex">
                    <div className="left-block">
                        <div className={'section-tag'}>Ready to start?</div>
                        <h2>Support For All Major <span>Kubernetes Platforms</span></h2>
                        <p>Middleware supports all major Kubernetes distributions, including, but not limited to, self-managed Kubernetes, Amazon Elastic Kubernetes Service (EKS), Azure Kubernetes Service (AKS), Google Kubernetes Service (GKE), Red Hat OpenShift.</p>
                        <Link href="https://docs.middleware.io/agent-installation/kubernetes" className="sign-up ahref-btn primary">Read Docs</Link>
                    </div>
                    <div className="right-block">
                        <img src={"/images/product/support-all-k8s-platform.webp"} alt={"Kubernetes Platforms Support"} width={500} height={400}/>
                    </div>
                </div>
                <div className="bottom-bar">
                    <p>Turn the Chaos of Kubernetes into Effortless Control! <Link href="https://app.middleware.io/auth/register/" className="start-monitoring-btn" target="_blank">Start Monitoring</Link></p>
                </div>
            </div>
        </section>
    </>
}
export default SupportK8sPlatforms;